import styled from 'styled-components';
import { COLOR_RED } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  .row {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .heading-block {
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 25px;
      width: 100%;
      .separator {
        border-radius: 2px;
        background-color: #d9d8dd;
        height: 1px;
        width: 100%;
      }
      p {
        min-width: fit-content;
        padding-right: 20px;
      }
    }

    .half-block {
      padding-top: 15px;
      width: calc(50% - 10px);
    }
    .full-block {
      padding-top: 15px;
      width: 100%;
    }

    .form-submit {
      width: 100%;
      margin: 15px 0 10px 0;
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    .row {
      .half-block {
        width: 100%;
      }
    }
  }
`;

export const PersonalFormTextInputSC = styled.input`
  border-radius: 2px;
  min-width: 100%;
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(63, 61, 86, 0.4);
  background-color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  border-radius: 12px;
  -webkit-appearance: none;

  &:read-only {
    opacity: 0.5;
    &:hover,
    &:focus {
      opacity: 0.5;
      border: 1px solid rgba(63, 61, 86, 0.4);
      outline: none;
      box-shadow: none;
    }
  }

  &::placeholder {
    color: #3f3d56;
    opacity: 0.3;
    font-weight: 400;
  }

  &:focus,
  &:hover {
    border: 1px solid #000000;
    outline: none;
    box-shadow: none;
    ${(props) => (props.hasError ? `border-color: ${COLOR_RED};` : 'border-color: #000000;')}
  }

  ${(props) => (props.hasError ? `color: ${COLOR_RED};` : null)}
  ${(props) => (props.hasError ? `border-color: ${COLOR_RED}` : null)}
`;

export const PersonalFormErrorSC = styled.div`
  width: 100%;
  height: auto;
  color: ${COLOR_RED};
`;
